import { render } from "./TransportEmissionsCalculator.vue?vue&type=template&id=6cb0f25e&scoped=true"
import script from "./TransportEmissionsCalculator.vue?vue&type=script&lang=js"
export * from "./TransportEmissionsCalculator.vue?vue&type=script&lang=js"

import "./TransportEmissionsCalculator.vue?vue&type=style&index=0&id=6cb0f25e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0f25e"]])

export default __exports__